import { useQuery } from 'react-query';
import { GetSessionContext } from '../apiCalls';
import { getProviderUserTypeGroup } from '../../scripts/providerUserType';
import { QueryKey } from './QueryKeys';

// Query for the session info.
const useSessionContext = () => {
	const { isLoading, isError, data, error } = useQuery(
		[QueryKey.GET_SESSION_CONTEXT],
		GetSessionContext,
		{ refetchOnWindowFocus: false }
	);

	const isLoggedIn = data?.resultCode === 0 && !!data?.data?.ashlinkUserId;
	const ashlinkUserId = data?.data?.ashlinkUserId || [];
	const ashlinkUserType = data?.data?.ashlinkUserType || [];
	const ashlinkUserEntityType = data?.data?.ashlinkUserEntityType || [];
	const ashlinkUserEntityStatus =
		data?.data?.ashlinkUserEntityStatus || undefined;
	const currentPermissions = data?.data?.permissions || [];
	const userInfoData = data?.data?.userInfo || {};
	const drFedId = data?.data?.drFedId || undefined;
	const currentLinks = data?.data?.ashlinkUserRedirections || [];
	const providerNetCode = data?.data?.providerNetCode || undefined;
	const practitionerId = data?.data?.practitionerId || undefined;
	const practitionerNetCode = data?.data?.practitionerNetCode || undefined;
	const providerId = data?.data?.providerId || undefined;
	const providerSpecialtyCode =
		data?.data?.providerSpecialtyCode || undefined;
	const practitionerSpecialtyCode =
		data?.data?.practitionerSpecialtyCode || undefined;
	const providerUserType = data?.data?.providerUserType || undefined;
	const providerUserTypeGroup = getProviderUserTypeGroup(providerUserType);
	const ssId = data?.data?.ssId || '';
	const flows = data?.data?.flows || [];
	const isTest = data?.data?.isTest || false;

	// isCompleted property keeps track of user flows
	const completedFlows = flows.map(flow => ({
		...flow,
		isCompleted: false,
	}));

	return {
		isLoading,
		isError,
		error,
		isLoggedIn,
		ashlinkUserId,
		ashlinkUserType,
		ashlinkUserEntityType,
		ashlinkUserEntityStatus,
		permissions: currentPermissions,
		redirectionLinks: currentLinks,
		userInfo: userInfoData,
		drFedId,
		providerNetCode,
		providerSpecialtyCode,
		practitionerId,
		practitionerNetCode,
		practitionerSpecialtyCode,
		providerId,
		providerUserType,
		providerUserTypeGroup,
		ssId,
		flows: completedFlows,
		isTest,
	};
};

export default useSessionContext;
